import {
    Container,
    Paper,
    TextField,
    Button,
    Typography,
    Alert
} from '@mui/material';
import { useState } from 'react';
import { db } from '../firebase/config';
import { addDoc, collection } from 'firebase/firestore';

export default function CreateFormFromJSON() {
    const [jsonText, setJsonText] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        try {
            const parsed = JSON.parse(jsonText);

            if (!parsed.title || !parsed.formType) {
                throw new Error('Invalid JSON structure');
            }

            setLoading(true);
            await addDoc(collection(db, 'forms'), {
                ...parsed,
                createdAt: new Date(),
                updatedAt: new Date()
            });

            alert('Form created successfully');
        } catch (err) {
            setError(err.message || 'Invalid JSON');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper sx={{ p: 3 }}>
                <Typography variant="h5" gutterBottom>
                    Create Form From JSON
                </Typography>

                {error && <Alert severity="error">{error}</Alert>}

                <TextField
                    fullWidth
                    multiline
                    minRows={15}
                    label="Paste JSON here"
                    value={jsonText}
                    onChange={(e) => setJsonText(e.target.value)}
                    sx={{ mt: 2 }}
                />

                <Button
                    variant="contained"
                    sx={{ mt: 2 }}
                    onClick={handleCreate}
                    disabled={loading}
                >
                    Create Form
                </Button>
            </Paper>
        </Container>
    );
}
